import { Injectable } from '@angular/core';

import { IParticipantsByStageSettings } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class ParticipantsByStageWidgetService {
    areSettingsValid(settings: IParticipantsByStageSettings): boolean {
        if (!settings.remote) {
            return false;
        }
        if (!settings.remote.event_id) {
            return false;
        }
        return true;
    }
}
